import React, { ReactNode } from 'react';
import { BoxProps, Box, Typography } from '@mui/material';
import { mergeSx } from '@client/helpers/mui.helpers';

type InputContainerProps = BoxProps & {
  title: string;
  children: ReactNode;
  width?: number | string;
  mt?: number;
};

const InputContainer = ({
  title,
  children,
  width,
  mt,
  sx,
  ...other
}: InputContainerProps) => (
  <Box {...other} sx={mergeSx({ width, mt }, sx)}>
    <Typography variant="subtitle2">{title}</Typography>
    {children}
  </Box>
);

export default InputContainer;
